import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import Translate from 'translate-components';
import  Arrow  from '../Footer/arrow.svg';
import Ad from '../../DynamicContent/Main/About__block/chess.png';

export default class PricingFeatures extends Component {


    componentDidMount() {
        window.scrollTo(0, 0)
    }


    render() {

        return (
            <section className="pricing-features">
                <div className="advantage-item right adv2">
                        <div className="advitem-image-holder small rodrigo">
                            <img src={Ad} width={460} className="a2"/>

                        </div>
                        <div className="advitem-inner right adv2">
                            <div className="adv-heading a2"><Translate>Flexible payment methods</Translate></div>
                            <div className="adv-text a2"><Translate>We provide you with a complete toolkit that make your business grow and prosper. Our innovative payment system the best proof of that.</Translate></div>
                            <Link className="adv-btn a2" to={`/${localStorage.getItem('lang')}/payments`}><Translate>Read more</Translate><img src={Arrow} width={16} alt=""/></Link>
                        </div>
                    </div>
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Basic/TrustBlocks/PricingFeatures.js